module.exports = __webpack_public_path__ + "assets/images/template/project/intro-desktop.jpg?v=6f2b545a";